import * as React from "react";
import { Form, TextInput } from "components";
import { useCurrentCase, useParams } from "duck";
import { FormValues, useUpdateNotes } from "./duck";

const Treatment: React.FC = () => {
  const { toothNumber } = useParams();

  const dentalChart = useCurrentCase(({ data }) =>
    data.client.patient.dentalChartings?.find(
      chart => chart.tooth === +toothNumber
    )
  );

  const defaultValues = React.useMemo(
    () => (dentalChart ? { notesTimer: dentalChart.notesTimer || "" } : null),
    [dentalChart]
  );

  const onChange = useUpdateNotes(
    dentalChart?._id || null,
    dentalChart?.fakeId || null
  );

  if (!defaultValues) {
    return null;
  }

  return (
    <Form<FormValues> defaultValues={defaultValues}>
      <Form.Watcher defaultValues={defaultValues} onChange={onChange} />
      <TextInput
        label="Notes"
        placeholder="Enter notes"
        name="notesTimer"
        type="text-area"
      />
    </Form>
  );
};

export default Treatment;
